import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ParticipantState {
  projectManagerVersion:number,
  businessManagerVersion:number,
  projectApproverVersion:number,
  projectManagerId:number,
  businessManagerId:number,
  projectApproverId:number,
  projectManager:string;
  businessManager:string;
  projectApprover:string;
  selectPartcipant:boolean;
  participantProjectInvoiceApprovalId: number | string | undefined;
  participantsProjectApprovalArray: any[];
   searchProjectManager:string,
  searchBusinessManager:string,
  searchProjectApprover:string
}

const initialState: ParticipantState = {
  projectManagerVersion:0,
  businessManagerVersion:0,
  projectApproverVersion:0,
  projectManagerId:0,
  businessManagerId:0,
  projectApproverId:0,
  projectManager:"",
  businessManager:"",
  projectApprover:"",
  selectPartcipant:false,
  participantProjectInvoiceApprovalId: 0,
  participantsProjectApprovalArray: [],
  searchProjectManager:"",
  searchBusinessManager:"",
  searchProjectApprover:""
};

const projectApprovalSlice = createSlice({
  name: "projectInvoiceApprover",
  initialState,
  reducers: {
    setProjectInvoiceApproval: (
      state,
      action: PayloadAction<Partial<ParticipantState>>
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setProjectInvoiceApproval } =
projectApprovalSlice.actions;
export default projectApprovalSlice.reducer;
